<template>
    <div class='overview'
         v-if="customer">
        <section class="is-medium is-bold">
            <div class="container">
                <div class="column">
                    <div class="subtitle is-spaced">
                        <nav class="breadcrumb"
                             aria-label="breadcrumbs">
                            <ul>
                                <router-link tag="li"
                                             active-class="is-active"
                                             :to="{ name: 'administration.customers' }"
                                             exact>
                                    <router-link :to="{ name: 'administration.customers' }"
                                                 exact>Kunder</router-link>
                                </router-link>

                                <router-link tag="li"
                                             active-class="is-active"
                                             :to="{ name: 'administration.customers.detail', params: { id: customer.id } }"
                                             exact>
                                    <router-link :to="{ name: 'administration.customers.detail', params: { id: customer.id } }"
                                                 exact>{{ customer.name }}</router-link>
                                </router-link>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </section>

        <section class="section">
            <div class="columns is-multiline">
                <div class="column is-6 is-12-touch">
                    <div class="card box is-radiusless is-shadowless">
                        <div class="card-body">
                            <div class="columns">
                                <div class="column is-4">
                                    <avatar :account="customer"
                                            :size="200" />
                                </div>
                                <div class="column is-8">
                                    <h1 class="title is-spaced is-4">{{ customer.name }}</h1>

                                    <div class="buttons">
                                        <button type="button"
                                                class="button is-small"
                                                @click="showInfoEditModal = true">
                                            <b-icon icon="pencil"
                                                    size="is-small" />
                                            <span>{{ $t('global.actions.edit') }}</span>
                                        </button>

                                        <info-edit-modal v-if="showInfoEditModal"
                                                         :customer="customer"
                                                         @close="showInfoEditModal = false"
                                                         @updated="(newCustomer) => this.customer = newCustomer" />

                                        <user-activation-toggle-button :user="customer.user" />
                                    </div>

                                    <ul>
                                        <li><b>Email:</b> {{ customer.user.email }}</li>
                                        <li><b>Telefonnummer:</b> {{ customer.phone_number }}</li>
                                        <li><b>Adresse:</b> {{ customer.address }}</li>
                                        <li><b>By:</b> {{ customer.city }}</li>
                                        <li><b>Postnummer:</b> {{ customer.postcode }}</li>
                                        <li><b>Hvor er kender du TF fra?:</b> {{ customer.referral }}</li>
                                        <li><br></li>
                                        <template v-if="customer.vat_number">
                                            <li><b>CVR-nummer:</b> {{ customer.vat_number }}</li>
                                            <li><b>Virksomhed:</b> {{ customer.company_name || 'Ukendt' }}</li>
                                        </template>
                                        <li v-else>Kunden har ikke registreret en virksomhed</li>
                                        <br />
                                        <li>
                                            <strong>Noter:</strong>
                                            <br />
                                            <template v-for="line in splitNotes">
                                                {{ line }} <br />
                                            </template>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="column is-6 is-12-touch">
                    <div class="card box is-radiusless is-shadowless">
                        <div class="card-body">
                            <p class="subtitle">
                                Projekter
                            </p>

                            <ul class="projects-list">
                                <li v-for="project in customer.projects">
                                    {{ project.name }} <br>

                                    <strong>Studerende: </strong>{{ project.student.name }} <br>

                                    <strong>Status: </strong>{{ $t(`projects.status.${project.status}`) }}
                                </li>

                                <p v-if="!customer.projects.length">Denne kunde har ikke nogen projekter.</p>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<style lang="scss" scoped>
@import '../../../../global/styles/variables';

.projects-list {
    li {
        padding-bottom: .5rem;
    }
}
</style>

<script>
import Avatar from '@/taskflex/users/components/Avatar';
import CustomerService from '@/taskflex/customers/services/CustomerService';
import UserActivationToggleButton from '@/taskflex/administration/components/UserActivationToggleButton';
import InfoEditModal from '@/taskflex/administration/components/customers/InfoEditModal';

export default {
    data() {
        return {
            customer: null,
            loading: false,
            showInfoEditModal: false,
            showProfileTextEditModal: false,
            showCreateRatingModal: false,
            showSkillsLevelEditModal: false,
        };
    },

    computed: {
        id() {
            const { id = null } = this.$route.params;

            return id;
        },
        splitNotes() {
            if (!this.customer.notes) return [];
            return this.customer.notes.split('\n');
        },
    },

    mounted() {
        this.load();

        this.$eventHub.$on('customer.detail.reload', this.load);
    },

    beforeDestroy() {
        this.$eventHub.$off('customer.detail.reload', this.load);
    },

    methods: {
        load() {
            this.loading = true;

            const options = {
                includes: [
                    'user',
                    'projects',
                    'projects.student',
                ],
            };

            CustomerService.find(this.id, options, ({ data }) => {
                this.customer = data;

                this.loading = false;
            });
        },
    },

    components: {
        Avatar,
        InfoEditModal,
        UserActivationToggleButton,
    },
};
</script>



// WEBPACK FOOTER //
// src/taskflex/administration/pages/customers/Detail.vue